import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { fetchBusinesses, fetchSingleBusiness } from "./thunkActions";

interface InitialState {
  isLoading: boolean;
  businesses: IUsers | null;
  singleBusiness: IUserDetails | null | any;
  isFetchingBusinessDetails: boolean;
}

const initialState: InitialState = {
  isLoading: false,
  isFetchingBusinessDetails: false,
  businesses: null,
  singleBusiness: null,
};

export const usersSlice = createSlice({
  name: "businesses",
  initialState,
  reducers: {
    clearBusinessesData: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.businesses = null;
      }
    },
    clearBusiness: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.singleBusiness = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinesses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBusinesses.fulfilled, (state, action) => {
        state.businesses = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchBusinesses.rejected, (state) => {
        state.isLoading = false;
      });
    builder
      .addCase(fetchSingleBusiness.pending, (state) => {
        state.isFetchingBusinessDetails = true;
      })
      .addCase(fetchSingleBusiness.fulfilled, (state, action) => {
        state.singleBusiness = action.payload;
        state.isFetchingBusinessDetails = false;
      })
      .addCase(fetchSingleBusiness.rejected, (state) => {
        state.isFetchingBusinessDetails = false;
      });
  },
});

export default usersSlice.reducer;
export const { clearBusinessesData, clearBusiness } = usersSlice.actions;
export * from "./thunkActions";
